export enum CacheKeys {
  ORGS = "organisations",
  USERS = "users",
  PRODUCTS = "products",
  USER_PRODUCTS = "userProducts",
  USER_ACCESSED_PRODUCTS = "userAccessedProducts",
  RESET_PASSWORD = "resetPassword",
  BANNED_IP = "bannedIP",
  API_ACCOUNTS = "apiAccounts",
  API_ACCOUNT_PRODUCTS = "apiAccountProducts",
  API_ACCOUNT_KEYS = "apiAccountKeys",
  BILLED_OPERATIONS = "billedOperations",
  BILLED_OPERATION_SUMMARIES = "billedOperationsSummaries",
  LICENCES = "licence",
  SOFTWARE = "software",
  SOFTWARE_LICENCES = "softwareLicences",
  BILLABLE_OPERATIONS = "billableOperations",
  PRICING = "pricing",
  ORDERS = "orders",
  TRACC_Usages = "traccUsages",
  COUNTRIES = "countries",
  CURRENCY = "currency",
  PENDING_LICENCE_PURCHASE = "pendingLicencePurchase",
}
